module.exports = __webpack_public_path__ + "static/media/mainimg-01.75716117.png";